import { useEffect, useState, useRef } from 'react';
import { Button, Drawer, Form, Input, Tag, Rate, message, Modal } from 'antd';
import { drawerWidth } from '@utils/property';
import { getExpertAndAgendaInfoApi } from '@services/Conference';
import { getExpertEvalDimensionsApi, saveExpertEvalRecordApi } from '@services/Experts';
import { expertLevels, starTexts } from '@utils/constants';
import { convertDateTimeRangeToLocalText } from '@utils/utils';
import WorkExperiences from '@/components/common/WorkExperiences';

import '../expert_evaluation.less';

// 开始评分
const EvaluationDrawer = props => {
    const { visibleEvaluationDrawer, setVisibleEvaluationDrawer, currentEvaluation, getExpertEvaluationList } = props;

    const [evaluationHallLoading, setEvaluationHallLoading] = useState(false); // 新增/编辑会议场次loading

    const [expertInfo, setExpertInfo] = useState({}); // 用户信息
    const [agendaInfo, setAgendaInfo] = useState({}); // 日程任务信息
    const [expertEvalDimensions, setExpertEvalDimensions] = useState({}); // 专家评价维度
    const [specialDescription, setSpecialDescription] = useState('');
    const [isNoEvaluation, setIsNoEvaluation] = useState(true); // 是否一个维度都没评价

    // 评分 星数
    const handleChange = (value, item) => {
        // console.log('item:' , item);
        setExpertEvalDimensions(prevState => ({
            ...prevState,
            [item.evalType]: prevState[item.evalType].map(ele => (ele.id === item.id ? { ...ele, isNoData: false, starNum: value } : ele)),
        }));
        setIsNoEvaluation(true);
    };

    // 提交评分
    const submitEvaluationHall = async () => {
        const params = [];

        const updatedData = expertEvalDimensions;
        let total = 0;

        Object.keys(updatedData).forEach(key => {
            updatedData[key].forEach(item => {
                if (!!item.starNum) {
                    const datas = {
                        activityId: currentEvaluation.conferenceId,
                        activityType: 'conference',
                        agendaId: currentEvaluation.agendaId,
                        evalId: item.id,
                        expertId: currentEvaluation.expertId,
                        remark: specialDescription,
                        starNum: item.starNum,
                        taskId: currentEvaluation.taskId,
                    };
                    params.push(datas);
                } else {
                    item.isNoData = true;
                }
            });

            total += updatedData[key].length;
        });

        setExpertEvalDimensions({ ...updatedData });

        console.log('updatedData', updatedData);

        if (!params.length) {
            setIsNoEvaluation(true);
            message.warning('请至少记录一个维度后再提交');
        } else if (total > params.length) {
            setIsNoEvaluation(false);

            Modal.confirm({
                title: '提示',
                content: '您有未记录的维度，提交后不可修改，确认继续提交？',
                okText: '确认提交',
                cancelText: '修改记录',
                onOk: async () => {
                    try {
                        setEvaluationHallLoading(true);
                        const res = await saveExpertEvalRecordApi(params);
                        if (res.status_code === 200) {
                            message.success('记录成功');
                            closeEvaluationDrawer();

                            getExpertEvaluationList();
                        }
                        setEvaluationHallLoading(false);
                    } catch (e) {
                        setEvaluationHallLoading(false);
                    }
                },
            });
        } else {
            try {
                setEvaluationHallLoading(true);
                const res = await saveExpertEvalRecordApi(params);
                if (res.status_code === 200) {
                    message.success('记录成功');
                    closeEvaluationDrawer();

                    getExpertEvaluationList();
                }
                setEvaluationHallLoading(false);
            } catch (e) {
                setEvaluationHallLoading(false);
            }
        }
    };

    // 关闭评分抽屉
    const closeEvaluationDrawer = () => {
        setVisibleEvaluationDrawer(false);
        setExpertInfo({});
        setAgendaInfo({});
        setExpertEvalDimensions({});
        setSpecialDescription('');
    };

    // 获取专家和日程信息
    const getExpertAndAgendaInfo = async () => {
        const res = await getExpertAndAgendaInfoApi({ agendaId: currentEvaluation.agendaId, expertId: currentEvaluation.expertId });
        if (res.status_code === 200) {
            // console.log(res.data);
            setExpertInfo(res.data.expert);
            setAgendaInfo(res.data.agendaInfo);
        }
    };

    // 获取专家价值维度
    const getExpertEvalDimensions = async () => {
        const res = await getExpertEvalDimensionsApi();
        if (res.status_code === 200) {
            // console.log(res.data);
            const datas = {
                合作友好度: [...res.data['合作友好度']],
                报告专业度: [...res.data['报告专业度']],
            };
            setExpertEvalDimensions(datas);
        }
    };

    useEffect(() => {
        if (!!visibleEvaluationDrawer && !!currentEvaluation?.expertId) {
            getExpertAndAgendaInfo();
            getExpertEvalDimensions(); // 专家记录维度
        }
    }, [visibleEvaluationDrawer]);

    return (
        <Drawer
            closable={{ placement: 'end' }}
            title="专家价值"
            size={drawerWidth}
            open={visibleEvaluationDrawer}
            onClose={closeEvaluationDrawer}
            layout="horizontal"
            mask={{ closable: false }}
            footer={
                <div style={{ textAlign: 'right' }}>
                    <Button type="primary" style={{ width: '100%', height: 40 }} loading={evaluationHallLoading} onClick={submitEvaluationHall}>
                        确定记录
                    </Button>
                </div>
            }
        >
            <div className="evaluation-container">
                <div className="evaluation-info">
                    <div className="expert-info">
                        <span>{expertInfo.memUsername}</span>
                        <span>{expertLevels.find(a => a.level === expertInfo.expertLevel)?.label}</span>
                        <span>
                            {!expertInfo?.memMobile || expertInfo?.memMobile?.startsWith('100') ? (
                                <Tag color="volcano" style={{ padding: 2, fontSize: 10, lineHeight: 1 }}>
                                    无手机号
                                </Tag>
                            ) : (
                                expertInfo?.memMobile
                            )}
                        </span>
                    </div>
                    <p>单位任职：</p>
                    <WorkExperiences workExperiences={expertInfo.ssoMemberWorkExperiencesEntities} layout="block" />

                    <div className="conference-info">
                        <h3>所属项目</h3>
                        <h2>{agendaInfo.name}</h2>
                        <h3>任务内容</h3>
                        <p>
                            {agendaInfo.title} <Tag color="blue">{agendaInfo.taskName}</Tag>
                        </p>
                        <span>{convertDateTimeRangeToLocalText(agendaInfo.start_time, agendaInfo.end_time, 0)}</span>
                    </div>
                </div>

                <p className="evaluation-tips">注：未记录的维度将不会计分，系统仅会根据您已记录的维度进行计算。</p>

                {!!Object.keys(expertEvalDimensions)
                    && Object.keys(expertEvalDimensions).map((keyname, index) => (
                        <div className="options-container" key={index}>
                            <h3 className="options-title">
                                <span>*</span> {keyname}
                            </h3>
                            <div className="options">
                                {!!expertEvalDimensions[keyname]
                                    && expertEvalDimensions[keyname].map((item, idx) => (
                                        <div className="option" key={item.id}>
                                            <p className={item.isNoData && !isNoEvaluation ? 'colorRed' : ''}>{item.name}</p>
                                            <Rate count={5} onChange={val => handleChange(val, item)} value={item.starNum} className="custom-rate" />
                                            <div className="star-texts">
                                                {starTexts.map((text, i) => (
                                                    <span key={i} className={item.starNum && item.starNum - 1 === i ? 'starActive' : ''}>
                                                        {text}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ))}

                <div className="description-box">
                    <h3>特殊说明</h3>
                    <Input.TextArea rows={5} placeholder="可填写合作意向、研究方向、专业兴趣、职业动向、主攻课题" showCount maxLength={200} value={specialDescription} onChange={e => setSpecialDescription(e.target.value)} />
                </div>
            </div>
        </Drawer>
    );
};
export default EvaluationDrawer;
